import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { withAnalytics } from '@redbubble/boom-analytics';
import DesignHeader from './Header';
import withUserAccount from '../../containers/apollo/withUserAccount';
import withBrowserInfo from '../../containers/redux/withBrowserInfo';
import withCart from '../../containers/apollo/withCart';
import withBannerMessages from '../../containers/apollo/withBannerMessages';
import withGlobalNavigation from '../../containers/apollo/withGlobalNavigation';

const Header = compose(
  injectIntl,
  withBrowserInfo,
  withRouter,
  withAnalytics,
  withGlobalNavigation,
  withUserAccount,
  withBannerMessages,
  withCart
)(DesignHeader);

Header.displayName = DesignHeader.displayName;

export default Header;
